'use client'

import React from 'react'
import { Sourcepoint } from '@/libs/Sourcepoint/Sourcepoint'
import AdAlliance from '@/libs/AdAlliance/AdAlliance'
import AppContext from '@/types/context'
import { Outbrain } from '@/libs/Outbrain/Outbrain'
import { AdDefend } from '@/libs/AdDefend/AdDefend'
import GoogleTagManager from '@/libs/Google/GoogleTagManager'
import InternalTracking from '@/libs/Tracking/InternalTracking'
import VGWortTracking from '@/libs/Tracking/VGWortTracking'
import GA4Tracking from '@/libs/Tracking/GA4Tracking'
import NetID from '@/libs/NetID/NetID'
import PublicRuntimeConfig from '@/libs/PublicRuntimeConfig/PublicRuntimeConfig'
import IFrameResizer from '@/libs/IFrameResizer/IFrameResizer'
import ConsentClickHandler from '@/libs/ConsentClickHandler/ConsentClickHandler'
import Webpush from '@/libs/Pushes/Webpush'
import Kameleoon from '@/components/Kameleoon/Kameleoon'
import Redirect from '@/libs/Redirects/Redirect'

export default function GlobalScripts({ context }: Readonly<{ context: AppContext }>) {
  return (
    <>
      <PublicRuntimeConfig />
      <IFrameResizer />
      <Sourcepoint cookies={context.cookies} />
      <AdAlliance context={context} />
      <Outbrain />
      <AdDefend />
      <GoogleTagManager context={context} />
      <InternalTracking context={context} />
      <VGWortTracking context={context} />
      <GA4Tracking context={context} />
      <NetID />
      <ConsentClickHandler />
      <Webpush context={context} />
      <Kameleoon />
      <Redirect />
    </>
  )
}
